import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faFileImage } from "@fortawesome/free-regular-svg-icons"

export const FileImageRegular = (props) => {
  return <FontAwesomeIcon faIcon={faFileImage} {...props} />
}
